import React from "react";
import cx from "classnames";
import stylesV2 from "./Toast.module.scss";
import stylesV3 from "./ToastV3.module.scss";

interface ToastProps {
  children: React.ReactNode;
  visible: boolean;
  toastClassName?: string;
  isV3?: boolean;
}

export const Toast: React.FC<ToastProps> = ({
  visible,
  children,
  toastClassName,
  isV3 = false,
}) => {
  const styles = isV3 ? stylesV3 : stylesV2;

  return (
    <div
      className={cx(
        styles.container,
        {
          [styles.visible]: visible,
        },
        toastClassName
      )}
      style={{ opacity: visible ? 1 : 0 }}
      role="alert"
    >
      <div className={styles.toast}>{children}</div>
    </div>
  );
};
